import { FormCard, type RowConfig } from 'design-system';
import type React from 'react';
import { strings } from 'strings';

interface MedicationStatusCardProps {
  messages: string[];
  cardLabel: string;
}

export const MedicationStatusCard: React.FC<MedicationStatusCardProps> = ({
  messages,
  cardLabel,
}) => {
  const messageRow: RowConfig[] = [
    {
      icon: 'warning',
      fields: [
        {
          type: 'list',
          label: cardLabel,
          display: messages,
        },
      ],
    },
  ];

  return (
    <FormCard
      cardColor="status-warning"
      showIcons={true}
      title={strings.LabelStatus}
      rows={messageRow}
    />
  );
};
